import * as React from 'react'
import { useEffect, useState } from 'react'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Paper from '@material-ui/core/Paper'
import { timeout } from '../../../App'
import GridItem from '../../grid/GridItem'
import GridContainer from '../../grid/GridContainer'
import Button from '../../button/RegularButton'
import { AddAlert } from '@material-ui/icons'
import Snackbar from '../../snackbar/Snackbar'
import CircularProgress from '@material-ui/core/CircularProgress'
import Backdrop from '@material-ui/core/Backdrop'
import DepartmentSignatures from '../DepartmentSignatures'
import CustomDateInput from '../../input/CustomDateInput'
import { initialNotificationState } from '../../utils/state/ApplicationState'
import { createDateFromString, stringifyDate } from '../../utils/DateUtils'
import { getApiUrl } from '../../../api/api'

export default function AdminConfirmedDepartureTable() {
  const [notification, setNotification] = useState(initialNotificationState)
  const [proceeding, setProceeding] = useState(true)
  const [departures, setDepartures] = useState([])
  const [departureDates, setDepartureDates] = useState([])

  useEffect(() => {
    let params = new URLSearchParams()
    params.append('status', 'CONFIRMED')

    getApiUrl(params)
      .get(`/admin/departures`)
      .then(function(response) {
        setProceeding(false)
        setDepartures(response.data)
        let dates = response.data.map((dp) => createDateFromString(dp.departureDate))
        setDepartureDates(dates)
      })
      .catch(function(error) {
        console.log(error)
      })
  }, [notification])

  const handleCloseDeparture = async (departureId, movedOut) => {
    setProceeding(true)
    await getApiUrl()
      .put(
        `/admin/departures/close`,
        {
          departureId: departureId,
          movedOut: stringifyDate(movedOut),
        },
      )
      .then(function() {
        setProceeding(false)
        setNotification({
          open: true,
          message: 'Auszug abgeschlossen',
          color: 'success',
        })
      })
      .catch(function(error) {
        setProceeding(false)
        setNotification({
          open: true,
          message: error.response.data.message,
          color: 'danger',
        })
      })
      .finally(
        setTimeout(function() {
          setNotification(initialNotificationState)
        }, timeout),
      )
  }

  if (proceeding) {
    return (
      <Backdrop open={proceeding}>
        <CircularProgress color="inherit"/>
      </Backdrop>
    )
  }

  return (
    <GridContainer>
      <Snackbar
        place="br"
        color={notification.color}
        icon={AddAlert}
        message={notification.message}
        open={notification.open}
        closeNotification={() =>
          setNotification({
            open: false,
            message: '',
            color: '',
          })
        }
        close
      />
      <GridItem xs={12} sm={12} md={12}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <TableContainer style={{ minHeight: '500px' }} component={Paper}>
              <Table aria-label="spanning table">
                <TableHead>
                  <TableRow>
                    <TableCell style={{ fontWeight: 600 }}>Name</TableCell>
                    <TableCell style={{ fontWeight: 600 }}>Email</TableCell>
                    <TableCell style={{ fontWeight: 600 }}>Zimmer</TableCell>
                    <TableCell style={{ fontWeight: 600 }}>Erstellt am</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {departures !== undefined
                    ? departures.map((row, index) => (
                      <React.Fragment key={row.departureId}>
                        <TableRow key={`tenant-${row.departureId}`}>
                          <TableCell>{row.tenantFullName}</TableCell>
                          <TableCell>
                            <a href={`mailto:${row.tenantEmail}`}> {row.tenantEmail} </a>
                          </TableCell>
                          <TableCell>{row.tenantRoom}</TableCell>
                          <TableCell>{row.createdOn}</TableCell>
                        </TableRow>
                        <TableRow key={`signatures-${row.departureId}`}>
                          <TableCell style={{ width: 140 }}>
                            <CustomDateInput
                              labelText="Auszugsdatum"
                              id={`date-${row.departureId}`}
                              formControlProps={{
                                fullWidth: true,
                              }}
                              inputProps={{
                                value: departureDates[index],
                                onChange: (date) => {
                                  let tmp = departureDates.slice()
                                  tmp[index] = date
                                  setDepartureDates(tmp)
                                },
                              }}
                            />
                            <Button
                              color="primary"
                              disabled={row.signatures.length !== 6}
                              onClick={() => {
                                handleCloseDeparture(row.departureId, departureDates[index])
                              }}>
                              Auszugsantrag schließen
                            </Button>
                          </TableCell>
                          <TableCell colSpan="4">
                            <DepartmentSignatures signatures={row.signatures}/>
                          </TableCell>
                        </TableRow>
                        <TableRow key={`placeholder-${row.departureId}`}>
                          <TableCell colSpan={5}/>
                        </TableRow>
                      </React.Fragment>
                    ))
                    : 'Nothing to display'}
                </TableBody>
              </Table>
            </TableContainer>
          </GridItem>
        </GridContainer>
      </GridItem>
    </GridContainer>
  )
}
